export default class HighlightText {
    static initAll() {
        const markedTexts = document.querySelectorAll("span.highlight-mark");

        if (markedTexts.length === 0)
            return
        
        markedTexts.forEach((markedText) => {
            markedText.dataset.text = markedText.innerHTML;
        });
    }
}